import { fabric } from 'fabric';
import { getObjectsByType } from '../../../utils/canvas';
import { CanvasDataTypes } from '../../../utils/canvas-utils/canvas-data-types';

/**
 * Get the next available photo zone for cover photos.
 * It finds all photo zones in the canvas, filters out those that already have content,
 * and returns the one with the lowest order value.
 * @param {fabric.Canvas} canvas - The fabric canvas to search for photo zones
 * @returns {fabric.Object | undefined} - The next available photo zone for cover photos
 */
export const getNextCoverPhotoZone = (canvas: fabric.Canvas) => {
  const photoZones = getObjectsByType(canvas, CanvasDataTypes.PhotoZone);
  const slots = photoZones.filter((zone) => !zone.data?.hasContent);
  let nextSlot = slots[0];
  slots.forEach((slot) => {
    if (slot.data.order < nextSlot.data.order) {
      nextSlot = slot;
    }
  });

  return nextSlot;
};
